import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import useThemeProps from "./useThemeProps.mjs";
import parseStyle from "./parseStyle.mjs";
function Avatar(props) {
  props = useThemeProps({
    props,
    name: "Avatar"
  });
  let {
    image,
    components = {},
    border,
    borderColor,
    style,
    ...restProps
  } = props;
  components = {
    Image: "img",
    ...components
  };
  const {
    Image
  } = components;
  const theme = useTheme();
  borderColor = borderColor ? theme.getColor(borderColor) : "";
  if (image) {
    return /* @__PURE__ */jsx(Image, {
      ...image,
      ...restProps,
      css: /* @__PURE__ */css("aspect-ratio:1;border-radius:50%;max-width:100%;height:auto;width:auto;border:", border, ";border-color:", borderColor, ";", parseStyle(style, theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9qZWFuZnJlZHJpay9wcm9qZWN0cy93c3VpL3BhY2thZ2VzL2Jhc2Uvc3JjL0F2YXRhci5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUJnQiIsImZpbGUiOiIvVXNlcnMvamVhbmZyZWRyaWsvcHJvamVjdHMvd3N1aS9wYWNrYWdlcy9iYXNlL3NyYy9BdmF0YXIuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHVzZVRoZW1lUHJvcHMgZnJvbSBcIi4vdXNlVGhlbWVQcm9wcy5qc3hcIjtcbmltcG9ydCBwYXJzZVN0eWxlIGZyb20gXCIuL3BhcnNlU3R5bGUuanNcIjtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gQXZhdGFyKHByb3BzKSB7XG4gIHByb3BzID0gdXNlVGhlbWVQcm9wcyh7IHByb3BzLCBuYW1lOiBcIkF2YXRhclwiIH0pO1xuICBsZXQge1xuICAgIGltYWdlLFxuICAgIGNvbXBvbmVudHMgPSB7fSxcbiAgICBib3JkZXIsXG4gICAgYm9yZGVyQ29sb3IsXG4gICAgc3R5bGUsXG4gICAgLi4ucmVzdFByb3BzXG4gIH0gPSBwcm9wcztcbiAgY29tcG9uZW50cyA9IHsgSW1hZ2U6IFwiaW1nXCIsIC4uLmNvbXBvbmVudHMgfTtcbiAgY29uc3QgeyBJbWFnZSB9ID0gY29tcG9uZW50cztcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBib3JkZXJDb2xvciA9IGJvcmRlckNvbG9yID8gdGhlbWUuZ2V0Q29sb3IoYm9yZGVyQ29sb3IpIDogXCJcIjtcbiAgaWYgKGltYWdlKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxJbWFnZVxuICAgICAgICB7Li4uaW1hZ2V9XG4gICAgICAgIHsuLi5yZXN0UHJvcHN9XG4gICAgICAgIGNzcz17Y3NzYFxuICAgICAgICAgIGFzcGVjdC1yYXRpbzogMTtcbiAgICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgICAgbWF4LXdpZHRoOiAxMDAlO1xuICAgICAgICAgIGhlaWdodDogYXV0bztcbiAgICAgICAgICB3aWR0aDogYXV0bztcbiAgICAgICAgICBib3JkZXI6ICR7Ym9yZGVyfTtcbiAgICAgICAgICBib3JkZXItY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICAgICR7cGFyc2VTdHlsZShzdHlsZSwgdGhlbWUpfVxuICAgICAgICBgfVxuICAgICAgLz5cbiAgICApO1xuICB9XG4gIHJldHVybiBudWxsO1xufVxuIl19 */")
    });
  }
  return null;
}
export { Avatar as default };